export default "__VITE_ASSET__BU5fkqC2__"